module.exports = "<div class=\"col-xs-4\">\r\n    <h3 *ngIf=\"mediaStats && mediaStats[0]\">\r\n        Statistiken für das Medium {{mediaStats[0].media.title}}\r\n    </h3>\r\n    <app-table-template *ngIf=\"mediaStats && columns\" [data]=\"mediaStats\" [columns]=\"columns\"></app-table-template><br>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/mediaStat/media.stat.component.html
// module id = 263
// module chunks = 1